import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';

// YouTube id for the current demo video. When a NEW demo is recorded, update this
// id AND bump DEMO_VIDEO_VERSION in Navigation.tsx so the auto-popup re-appears
// for everyone the next time they log in.
export const DEMO_VIDEO_YOUTUBE_ID = 'm-BY8c99mFk';

type Props = {
  show: boolean;
  onHide: () => void;
};

type State = {
  show: boolean;
};

export class DemoVideoModal extends React.Component<Props, State> {
  state: State = {
    show: this.props.show
  };

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      show: nextProps.show
    });
  }

  handleClose = () => {
    this.props.onHide();
  }

  render() {
    if (!this.state.show) {
      return null;
    }

    return (
      <Modal show={this.state.show} onHide={this.handleClose} size="lg">
        <Modal.Header closeButton style={{ backgroundColor: '#337ab7', color: '#fff' }}>
          <Modal.Title>Welcome — Watch the LabSmarts Demo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Take a quick tour of what LabSmarts can do. You can watch this again any time
            from the <b>Help</b> menu.
          </p>
          {/* Responsive 16:9 embed */}
          <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
            <iframe
              title="LabSmarts Demo Video"
              src={`https://www.youtube.com/embed/${DEMO_VIDEO_YOUTUBE_ID}`}
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
